// PILLS i18n engine — react-i18next + http backend.
// English source strings are the keys (returnEmptyString=false, falls back to key).
// Translations served by GET /api/i18n/translations?lang=xx&namespace=ui (cached 1h server-side).

import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

// Detect initial language: localStorage → navigator → 'en'.
const SUPPORTED = ["en", "hi", "te", "ta", "ml", "kn", "mr", "or", "bn", "gu", "ur", "pa", "as"];

const detectInitial = () => {
    if (typeof window === "undefined") return "en";
    try {
        const fromLS = window.localStorage.getItem("pills-lang");
        if (fromLS && SUPPORTED.includes(fromLS)) return fromLS;
    } catch { /* ignore */ }
    const nav = (window.navigator?.language || "en").slice(0, 2).toLowerCase();
    return SUPPORTED.includes(nav) ? nav : "en";
};

i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
        lng: detectInitial(),
        fallbackLng: "en",
        ns: ["ui"],
        defaultNS: "ui",
        supportedLngs: SUPPORTED,
        load: "languageOnly",
        interpolation: { escapeValue: false },
        // Use English source strings as keys; missing translation returns the key.
        keySeparator: false,
        nsSeparator: false,
        returnEmptyString: false,
        saveMissing: false,
        backend: {
            loadPath: `${API_BASE}/api/i18n/translations?lang={{lng}}&namespace={{ns}}`,
            // Server returns { lang, namespace, translations: {...}, count }.
            parse: (data) => {
                try {
                    const obj = typeof data === "string" ? JSON.parse(data) : data;
                    return obj?.translations || {};
                } catch {
                    return {};
                }
            },
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;

// Helpers
export const RTL_LANGS = ["ur"];

export const applyDir = (lang) => {
    if (typeof document === "undefined") return;
    const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
};

export const persistLang = (lang) => {
    try { window.localStorage.setItem("pills-lang", lang); } catch { /* ignore */ }
};

// Initial apply (in case index loads before any component mounts)
if (typeof window !== "undefined") {
    applyDir(i18n.language || "en");
}
